<template>
    <!-- This is a headless component, it doesn't render anything visually -->
  </template>
  
  <script setup>
  import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
  
  const props = defineProps({
    // The type of Schema.org entity (e.g., 'TravelAgency', 'TouristAttraction', 'Article')
    type: {
      type: String,
      required: true
    },
    // The data to include in the schema
    data: {
      type: Object,
      required: true
    }
  });
  
  const scriptElement = ref(null);
  
  // Create and inject structured data on component mount
  onMounted(() => {
    injectStructuredData();
  });
  
  // Update structured data when props change
  watch(() => props.data, () => {
    if (scriptElement.value) {
      document.head.removeChild(scriptElement.value);
    }
    injectStructuredData();
  }, { deep: true });
  
  // Remove structured data when component unmounts
  onBeforeUnmount(() => {
    if (scriptElement.value) {
      document.head.removeChild(scriptElement.value);
    }
  });
  
  // Helper function to inject structured data
  function injectStructuredData() {
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    
    // Prepare the schema
    const schema = {
      '@context': 'https://schema.org',
      '@type': props.type,
      ...props.data
    };
    
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    
    // Store reference for future updates
    scriptElement.value = script;
  }
  </script>